module.exports = __webpack_public_path__ + "static/media/wallet-logo.5d8d3b97.svg";